const shadows = [
  'none',
  '0px 4px 8px rgba(0, 0, 0, 0.1)', // softer drop shadow
  '0px 6px 12px rgba(0, 0, 0, 0.1)',
  '0px 8px 16px rgba(0, 0, 0, 0.1)',
  '0px 10px 20px rgba(0, 0, 0, 0.1)',
  '0px 12px 24px rgba(0, 0, 0, 0.12)',
  '0px 14px 28px rgba(0, 0, 0, 0.12)',
  '0px 16px 32px rgba(0, 0, 0, 0.12)',
  '0px 18px 36px rgba(0, 0, 0, 0.12)',
  '0px 20px 40px rgba(0, 0, 0, 0.12)',
  '0px 22px 44px rgba(0, 0, 0, 0.12)',
  '0px 24px 48px rgba(0, 0, 0, 0.12)',
  '0px 26px 52px rgba(0, 0, 0, 0.14)',
  '0px 28px 56px rgba(0, 0, 0, 0.14)',
  '0px 30px 60px rgba(0, 0, 0, 0.14)',
  '0px 32px 64px rgba(0, 0, 0, 0.16)',
  '0px 34px 68px rgba(0, 0, 0, 0.16)',
  '0px 36px 72px rgba(0, 0, 0, 0.16)',
  '0px 38px 76px rgba(0, 0, 0, 0.18)',
  '0px 40px 80px rgba(0, 0, 0, 0.18)',
  '0px 42px 84px rgba(0, 0, 0, 0.18)',
  '0px 44px 88px rgba(0, 0, 0, 0.2)',
  '0px 46px 92px rgba(0, 0, 0, 0.2)',
  '0px 48px 96px rgba(0, 0, 0, 0.2)',
  '0px 50px 100px rgba(0, 0, 0, 0.22)',
];

const darkshadows = [
  'none',
  '0px 4px 8px rgba(0, 0, 0, 0.3)', // softer, more subtle shadow for dark mode
  '0px 6px 12px rgba(0, 0, 0, 0.3)',
  '0px 8px 16px rgba(0, 0, 0, 0.3)',
  '0px 10px 20px rgba(0, 0, 0, 0.3)',
  '0px 12px 24px rgba(0, 0, 0, 0.3)',
  '0px 14px 28px rgba(0, 0, 0, 0.3)',
  '0px 16px 32px rgba(0, 0, 0, 0.3)',
  '0px 18px 36px rgba(0, 0, 0, 0.3)',
  '0px 20px 40px rgba(0, 0, 0, 0.3)',
  '0px 22px 44px rgba(0, 0, 0, 0.3)',
  '0px 24px 48px rgba(0, 0, 0, 0.3)',
  '0px 26px 52px rgba(0, 0, 0, 0.3)',
  '0px 28px 56px rgba(0, 0, 0, 0.3)',
  '0px 30px 60px rgba(0, 0, 0, 0.3)',
  '0px 32px 64px rgba(0, 0, 0, 0.3)',
  '0px 34px 68px rgba(0, 0, 0, 0.3)',
  '0px 36px 72px rgba(0, 0, 0, 0.3)',
  '0px 38px 76px rgba(0, 0, 0, 0.3)',
  '0px 40px 80px rgba(0, 0, 0, 0.3)',
  '0px 42px 84px rgba(0, 0, 0, 0.3)',
  '0px 44px 88px rgba(0, 0, 0, 0.3)',
  '0px 46px 92px rgba(0, 0, 0, 0.3)',
  '0px 48px 96px rgba(0, 0, 0, 0.3)',
  '0px 50px 100px rgba(0, 0, 0, 0.3)',
];

export { shadows, darkshadows };
